import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { Link, useNavigate } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './RecommendationsGallery.scss';
import 'swiper/css';
import { Swiper as SwiperClass } from 'swiper/types';
import { SYSTEM_DEVICE, useSystemDevice } from '../../hooks/useSystemDevice';

SwiperCore.use([Navigation, Pagination]);

interface RecommendationsGalleryItem {
  description?: string;
  imageSrc: string;
  linkPath: string;
  name?: string;
}

export interface Props {
  className?: string;
  data: RecommendationsGalleryItem[];
}

const RecommendationsGallery: React.FC<Props> = (props) => {
  const scope = 'RecommendationsGallery';
  const systemDevice = useSystemDevice();
  const { t } = useTranslation();
  const [swiper, setSwiper] = useState<SwiperClass>();
  const navigate = useNavigate();

  useEffect(() => {
    if (swiper && !swiper.destroyed) {
      swiper.slideTo(0);
    }
  }, [props.data, swiper]);

  const items = props.data.map((item, index) => {
    return (
      <div className={`${scope}-item`} key={index}>
        <img src={item.imageSrc} className={`${scope}-image`} />
        <div className={`${scope}-itemInfo`}>
          <div className={`${scope}-itemInfoText`}>
            <div className={`${scope}-itemDescription`}>{item.description}</div>
            <div className={`${scope}-itemName`}>{item.name}</div>
          </div>
          <SVG
            className={`${scope}-itemArrow`}
            src={`${process.env.PUBLIC_URL}/media/arrow-right-1.svg`}
          />
        </div>
      </div>
    );
  });

  const clickSlide = (item: RecommendationsGalleryItem, index: number) => {
    if (swiper?.activeIndex === index) {
      navigate(item.linkPath);
    } else {
      swiper?.slideTo(index);
    }
  };

  const className = [scope, `${scope}--${systemDevice}`, props.className]
    .filter((className) => className)
    .join(' ');

  return (
    <section className={className}>
      <div className={`${scope}-title`}>
        {t('you_also_might_be_interested_in')}
      </div>
      {systemDevice === SYSTEM_DEVICE.DESKTOP ? (
        <div className={`${scope}-grid`}>
          {props.data.map((item, index) => (
            <Link
              className={`${scope}-gridItem`}
              key={index}
              to={item.linkPath}
            >
              {items[index]}
            </Link>
          ))}
        </div>
      ) : (
        <Swiper
          className={`${scope}-swiper`}
          onSwiper={setSwiper}
          pagination={{
            bulletActiveClass: `${scope}-paginationItem--active`,
            bulletClass: `${scope}-paginationItem`,
            clickable: true,
            clickableClass: `${scope}-pagination`,
            type: 'bullets',
          }}
          slidesPerView={1}
          spaceBetween={10}
          watchSlidesProgress={true}
          wrapperClass={`${scope}-swiperWrapper`}
        >
          {props.data.map((item, index) => (
            <SwiperSlide
              className={`${scope}-slide`}
              key={index}
              onClick={() => clickSlide(item, index)}
            >
              {items[index]}
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </section>
  );
};
export default RecommendationsGallery;
